import React from 'react';

const Input = ({
    label,
    name,
    type = 'text',
    value,
    placeholder,
    onChange,
    helpText,
}) => (
    <div className="mb-6">
        <label htmlFor={name} className="block text-sm font-medium leading-5 text-gray-700">
            {label}
        </label>
        <div className="mt-1 rounded-md shadow-sm">
            <input
                name={name}
                type={type}
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300
                    rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue
                    focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                value={value}
                placeholder={placeholder}
                onChange={onChange}
            />
        </div>
        { helpText && (
            <p className="mt-1 text-sm text-gray-500">
                {helpText}
            </p>
        )}
    </div>
);

export default Input;
